(() => {
  if (window.nfmQuoteSelectionReady) return;
  const config = document.querySelector('[data-nfm-quote-selection]');
  if (!config) return;
  window.nfmQuoteSelectionReady = true;
  const scope = config.closest('[id^="ProductInfo-"]');
  if (!scope) return;
  let pending = null;
  function refresh() {
    document.querySelectorAll('#storeify-chooseproduct-modal .storeify-modal-close, #storeify-mes-modal .storeify-modal-close').forEach(button => {
      if (button.textContent !== config.dataset.more) button.textContent = config.dataset.more;
    });
    scope.querySelectorAll('.storeify-quote-btn-trigger-popup').forEach(button => {
      if (button.dataset.product === config.dataset.handle && button.textContent !== config.dataset.choose) button.textContent = config.dataset.choose;
    });
    const modal = document.getElementById('storeify-chooseproduct-modal');
    if (!modal || !modal.classList.contains('target') || !pending) return;
    const select = modal.querySelector('#storeify_option_variants');
    const handle = modal.querySelector('#ify_handle_txt');
    if (!select || handle?.value !== config.dataset.handle || select.dataset.nfmReady === 'true') return;
    const option = Array.from(select.options).find(item => item.value === pending.id && !item.disabled);
    if (!option) return;
    select.value = pending.id;
    select.dataset.nfmReady = 'true';
    const summary = document.createElement('div');
    summary.className = 'nfm-quote-summary';
    const label = document.createElement('span');
    label.textContent = config.dataset.selected;
    const name = document.createElement('strong');
    name.textContent = option.textContent;
    const change = document.createElement('button');
    change.type = 'button';
    change.textContent = config.dataset.change;
    change.addEventListener('click', () => {
      modal.querySelector('.storeify-frm-close')?.click();
      const picker = scope.querySelector('variant-selects select, variant-radios input');
      picker?.focus();
    });
    summary.append(label, name, change);
    select.parentElement.before(summary);
    const photo = modal.querySelector('.storeify-thumbnail');
    if (photo && option.dataset.img) { photo.src = option.dataset.img; photo.alt = option.dataset.name || option.textContent; }
    const qty = modal.querySelector('#ify_qty_input');
    if (qty) {
      qty.type = 'number'; qty.min = config.dataset.minimum; qty.step = '1';
      qty.value = String(Math.max(Number(qty.value) || 1, Number(qty.min) || 1));
      qty.setAttribute('aria-label', config.dataset.quantity);
      const qtyLabel = document.createElement('label');
      qtyLabel.htmlFor = qty.id; qtyLabel.className = 'nfm-quote-quantity-label'; qtyLabel.textContent = config.dataset.quantity;
      qty.before(qtyLabel);
    }
    modal.classList.add('nfm-selection-ready');
  }
  document.addEventListener('click', event => {
    const add = event.target.closest('#storeify-chooseproduct-modal.nfm-selection-ready .storeify-add-to-quote');
    if (add) {
      const quantity = document.querySelector('#storeify-chooseproduct-modal #ify_qty_input');
      if (quantity && (!quantity.value || !quantity.checkValidity())) {
        event.preventDefault(); event.stopImmediatePropagation(); quantity.reportValidity(); return;
      }
    }
    const trigger = event.target.closest('.storeify-quote-btn-trigger-popup');
    if (trigger) {
      document.getElementById('storeify-chooseproduct-modal')?.classList.remove('nfm-selection-ready');
      pending = null;
      if (scope.contains(trigger) && trigger.dataset.product === config.dataset.handle) {
        const input = scope.querySelector('form[action*="/cart/add"] [name="id"]');
        const id = input?.value || new URL(location.href).searchParams.get('variant');
        if (id) pending = {id: String(id)};
      }
    }
  }, true);
  const observer = new MutationObserver(refresh);
  observer.observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['class']});
  refresh();
})();
